import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'smart-cart-form-custom-template-confirm-dialog',
  templateUrl: './custom-template-confirm-dialog.component.html',
  styleUrls: ['./custom-template-confirm-dialog.component.scss'],
  standalone: false,
})
export class SmartCartFormCustomTemplateConfirmDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<SmartCartFormCustomTemplateConfirmDialogComponent, boolean>) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
